import { PrequalResultOption } from "./equifax-credit-report"
import { EquifaxPrequalReport } from "./equifax-credit-report"
import { CriteriaEvaluationResult } from "./equifax-credit-report"
import { Document, Schema } from "mongoose"
import { UploadedDoc } from "./document-types"
import { EquifaxDitReportDetail } from "./equifax-dit-report"

export enum CreditReportType {
  Prequal = 'prequal',
  Dit = 'dit',
  PrequalCombined = 'prequal-combined',
  PrequalCoborrower = 'prequal-coborrower'
}

export type CreditReport = {
  _id: Schema.Types.ObjectId
  source: string
  reportType: CreditReportType
  report: any
  request: any
  evaluation?: CriteriaEvaluationResult // deprecated in favor of evaluations
  evaluations?: Schema.Types.ObjectId[] | CriteriaEvaluationResult[]
  combinedFrom?: Schema.Types.ObjectId
  combinedWith?: Schema.Types.ObjectId | CreditReport
  comboName?: String
  consumerId?: Schema.Types.ObjectId
  principalId?: Schema.Types.ObjectId
  loanAppId?: Schema.Types.ObjectId
  uploadedDoc?: UploadedDoc
  getPrequalResult: (evaluations?: CriteriaEvaluationResult[]) => PrequalResultOption
  getConsumerName: () => string
  getRawPrequalReport: () => EquifaxPrequalReport
  ofacAlerts: () => EquifaxDitReportDetail[]
  hasOfacAlerts: () => boolean
} & Document
